import React from "react";
import Lottie from "lottie-react";
import NotFoundAnimation from "../../assets/NotFound.json";

const NotFound = () => {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen text-gray-800">
      <div className="w-80">
        <Lottie animationData={NotFoundAnimation} loop={true} />
      </div>
      <h1 className="text-3xl font-bold mt-4">404 - Page Not Found</h1>
      <p className="text-gray-600 mt-2">Oops! The page you're looking for doesn't exist.</p>
    </div>
  );
};

export default NotFound;
